import React from 'react';
import './KeyTools.scss';
import { AddButton } from '../buttons/Buttons';
import { ZoomSection } from './zoomSection/ZoomSection';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../Redux/Store/store';
import { AddAnimationPayloadInterface, PlayStopAction } from '../../../../Redux/Actions/Animator/animation.list.action';

import { css } from 'glamor';
import { propEq, find } from 'ramda';
import { ObserverAnim, GLOBAL_EVENT_ANIM } from '../../Observer';

const button_disable = css({
    opacity: 0.2
});

const KeyTools = () => {
    const animation_list = useSelector((state: RootState) => state.AnimationList);
    const actual_animation: AddAnimationPayloadInterface = find(propEq('id', animation_list.actual_animation), animation_list.animations);

    const dispatch = useDispatch();

    return (
        <div className="key-tools d-flex justify-content-between align-item-center">
            <div className="zoom-section ml-5 pr-3 my-2">
                <ZoomSection />
            </div>
            <div className="media-section mr-5 pl-3 my-2">
                {
                    ((actual_animation === undefined) || actual_animation.frames.length < 1)
                        ?
                        <AddButton className={`ml-1 ${button_disable}`} onClick={() => {
                            ObserverAnim.emit(GLOBAL_EVENT_ANIM.NOTIFICATION_SYSTEM.WARNING, 'You must create animations and import frames');
                        }}>
                            <span className="material-icons">
                                play_arrow
                            </span>
                        </AddButton>
                        :
                        <AddButton className="ml-1" onClick={() => {
                            dispatch(PlayStopAction({
                                id: animation_list.actual_animation,
                                play: !actual_animation.play
                            }));
                        }}>
                            <span className="material-icons">
                                {(actual_animation.play) ? 'stop' : 'play_arrow'}
                            </span>
                        </AddButton>

                }
            </div>
        </div>
    )
}

export default KeyTools;
